export default {"src":"/_next/static/media/subscription.d8628019.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};